export const STEP = {
  INFO: 'info',
  NOT_ALLOWED: 'notAllowed',
  MAKE_CRYPTO_PAYMENT: 'makeCrypto',
  CRYPTO_PAYMENT: 'crypto',
};

export const MIN_AMOUNT = 10;

export const MAX_DEPOSIT_AMOUNT = 5000;

export const HIGH_MIN_AMOUNT = 20;

export const HIGH_MIN_CURRENCIES = ['btc', 'eth'];

export const CRYPTO_PAYMENT_BONUS = 4;

export const EMAIL_UNVERIFIED = 'email_unverified';

export const DEFAULT_SPLIT = 1;

export const MAX_SPLIT = 30;

export const GOOGLE_MAPS_POWER_SPLIT_MAX = 50;

export const ERROR_STATUSES = {
  failed: {
    titleKey: 'title.cryptoPaymentFailed',
    messageKey: 'description.cryptoPaymentProcessingProblem',
  },
  refunded: {
    titleKey: 'title.cryptoPaymentRefunded',
    messageKey: 'description.cryptoPaymentRefundedWallet',
  },
  expired: {
    titleKey: 'title.cryptoPaymentExpired',
    messageKey: 'description.cryptoPaymentExpired',
  },
};

export const SUCCESS_STATUSES = ['finished', 'partially_paid'];

export const CURRENCY_OPTIONS = [
  { value: 'btc', label: 'BTC' },
  { value: 'eth', label: 'ETH (Mainnet)' },
  { value: 'usdtbsc', label: 'USDT (BSC)' },
  { value: 'usdttrc20', label: 'USDT (TRC20)' },
  { value: 'usdtmatic', label: 'USDT (POLYGON)' },
  { value: 'usdtsol', label: 'USDT (SOL)' },
  { value: 'usdc', label: 'USDC (ETH)' },
  { value: 'usdcbsc', label: 'USDC (BSC)' },
  { value: 'usdcmatic', label: 'USDC (POLYGON)' },
  { value: 'usdcsol', label: 'USDC (SOL)' },
  { value: 'xmr', label: 'Monero (XMR)' },
];
